import React, { useState } from 'react';

const sampleRanks = [
  { name: 'Nour art Name', points: 8457 },
  { name: 'Ware Name', points: 12500 },
  { name: 'Soled Name', points: 23520 },
  { name: 'Sowly Now', points: 84000 },
  { name: 'You', points: 5700 }
];

const Leaderboard = ({ user }) => {
  const [tab, setTab] = useState('daily');

  // Find user's rank in sample data
  const userIndex = sampleRanks.findIndex(r => r.name === 'You');

  return (
    <div className="max-w-4xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-bold mb-4">Sales Champions</h1>

      <div className="bg-white rounded-lg shadow p-4 mb-6">
        <div className="flex space-x-3">
          {['daily','weekly','monthly'].map(t => (
            <button
              key={t}
              onClick={() => setTab(t)}
              className={`px-3 py-2 rounded-md ${tab===t ? 'bg-indigo-600 text-white' : 'bg-gray-100 text-gray-700'}`}
            >
              {t.charAt(0).toUpperCase() + t.slice(1)}
            </button>
          ))}
        </div>

        <div className="mt-4">
          <div className="bg-gray-50 rounded-md p-3">
            <h3 className="text-sm text-gray-600">Top Ranks</h3>
            <ol className="mt-3 space-y-2">
              {sampleRanks.slice(0,5).map((r,idx) => (
                <li key={r.name} className="flex items-center justify-between bg-white p-3 rounded shadow-sm">
                  <div className="flex items-center space-x-3">
                    <div className="h-10 w-10 rounded-full bg-indigo-100 flex items-center justify-center font-semibold">{idx+1}</div>
                    <div>
                      <div className="text-sm font-medium">{r.name}</div>
                      <div className="text-xs text-gray-500">{r.points} Points</div>
                    </div>
                  </div>
                  <div className="text-sm text-gray-700 font-semibold">{r.points}</div>
                </li>
              ))}
            </ol>
          </div>

          {userIndex >= 0 && (
            <div className="mt-3 text-sm text-gray-600">You are #{userIndex+1} today — just 20 points behind Anju!</div>
          )}
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-4">
        <p className="text-sm text-gray-500">Motivational message: Keep pushing, you're close to the top!</p>
      </div>
    </div>
  );
};

export default Leaderboard;
